import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';

@Api('api/agentic-cx/campaign-execution')
export class CampaignSummaryDto extends DtoHasApi {
  campaignId = 0;
  name = '';
  startDateUtc: string | null = null;
  endDateUtc: string | null = null;
  pendingEligibleCount = 0;
  totalContacts = 0;
  completedContacts = 0;
}
